export default function PatientTabsProfile({ activeTab, setActiveTab }) {
  return (
    <div className="flex border-b mx-5 mb-4 gap-8 border-gray-200 text-sm font-medium text-gray-500">
      <button
        onClick={() => setActiveTab("main")}
        className={`flex items-center gap-2 px-4 py-2 border-b-2 transition-all ${
          activeTab === "main"
            ? "border-blue-600 text-blue-600"
            : "border-transparent hover:text-gray-600"
        }`}
      >
        <svg
          className={"w-5 h-5"}
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            fillRule="evenodd"
            d="M12 20a7.966 7.966 0 0 1-5.002-1.756l.002.001v-.683c0-1.794 1.492-3.25 3.333-3.25h3.334c1.84 0 3.333 1.456 3.333 3.25v.683A7.966 7.966 0 0 1 12 20ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10c0 5.5-4.44 9.963-9.932 10h-.138C6.438 21.962 2 17.5 2 12Zm10-5c-1.84 0-3.333 1.455-3.333 3.25S10.159 13.5 12 13.5c1.84 0 3.333-1.455 3.333-3.25S13.841 7 12 7Z"
            clipRule="evenodd"
          />
        </svg>
        Main Information
      </button>
      <button
        onClick={() => setActiveTab("forms")}
        className={`flex items-center gap-2 px-4 py-2 border-b-2 transition-all ${
          activeTab === "forms"
            ? "border-blue-600 text-blue-600"
            : "border-transparent hover:text-gray-600"
        }`}
      >
        <svg
          className="w-5 h-5"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M15 4h3a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3m0 3h6m-6 5h6m-6 4h6M10 3v4h4V3h-4Z"
          />
        </svg>
        Forms
      </button>
    </div>
  );
}
